module.exports = __webpack_public_path__ + "img/jsonrpc.3e31ed20.png";